module.exports = __webpack_public_path__ + "media/team/bg-b137eda0.svg";